
export default function (Component) {
  Component.options.__source = "src/components/TestTools/RouterTools.vue"
}
